<template>
    <component :is="template">
        <div class="contents-area">
            <!-- <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">유아동</h2>
            </div> -->

            <div class="contents-area__inner">
                <shop-banner class="mb-30px mb-md-40px">
                    <div v-for="(banner, index) in banners" :key="index" class="swiper-slide">
                        <a :href="banner.link" target="_blank" class="shop-banner">
                            <div class="shop-banner__inner" :style="'background-image: url(' + banner.image + ')'"></div>
                        </a>
                    </div>
                </shop-banner>
                <div v-if="category" class="mb-30px mb-md-40px">
                    <!-- <v-tabs show-arrows grow class="tab tab--block">
                        <v-tab @click="filter._category = category._id">전체</v-tab>
                        <v-tab v-for="category in category.children" :key="category._id" @click="filter._category = category._id">{{ category.name }}</v-tab>
                    </v-tabs> -->
                    <v-btn-toggle class="w-100">
                        <v-row no-gutters>
                            <v-col>
                                <v-btn :class="filter._category == category._id ? 'primary': 'v-btn--outlined grey--text'" block x-large @click="filter._category = category._id">
                                    <span :class="filter._category == category._id ? '': 'grey--text text--darken-3'">전체</span>
                                </v-btn>
                            </v-col>
                            <template v-for="category in category.children">
                                <v-col :key="category._id" class="ml-md-n1px">
                                    <v-btn :class="filter._category == category._id ? 'primary': 'v-btn--outlined grey--text'" block x-large @click="filter._category = category._id">
                                        <span :class="filter._category == category._id ? '': 'grey--text text--darken-3'">{{ category.name }}</span>
                                    </v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </v-btn-toggle>
                </div>

                <div class="mt-30px">
                    <v-divider class="border-2 grey lighten-1"/>
                    <div class="py-10px py-md-6px">
                        <v-row align="center" class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="font-size-14">
                                    검색된 상품: <b class="primary--text">{{ summary.totalCount.format() }}</b>개
                                </div>
                            </v-col>
                            <v-spacer/>
                            <v-col cols="12" md="auto">
                                <v-select v-model="sort" :items="sortItems" item-text="text" value="value" outlined hide-details @input="search(false)"/>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider class="grey lighten-1"/>
                </div>

                <div class="py-20px py-md-30px">
                    <v-row>
                        <v-col v-for="product in products" :key="product._id" cols="6" md="3">
                            <router-link :to="`/shop/children/${product._id}`">
                                <v-img :src="product.thumb" width="100%" :aspect-ratio="200/160" contain class="mx-auto"></v-img>
                                <div class="mt-4 text-center grey--text text--darken-4">
                                    <div class="font-size-18 font-size-md-20 font-weight-medium text-truncate">{{ product.name }}</div>
                                    <v-layout class="font-size-14 text-truncate mt-1" justify-center>
                                        <span>{{ product.writer }}</span>
                                        <v-divider v-if="product.writer && product.publisher" vertical class="mx-2 my-1"/>
                                        <span>{{ product.publisher }}</span>
                                    </v-layout>
                                    <div class="d-flex align-center justify-center primary--text mt-md-1">
                                        <span class="font-size-16 font-size-md-18 font-weight-bold">{{ product.salePrice.format() }}</span>
                                        <small class="font-size-14 font-weight-medium ml-1">원</small>
                                    </div>

                                    <v-layout wrap justify-center class="mt-2 mr-n1">
                                        <v-flex v-if="product.isRecommend" shrink class="pr-1"><v-chip color="#FA647D" dark x-small >추천</v-chip></v-flex>
                                        <v-flex v-if="product.isNewly" shrink class="pr-1"><v-chip color="#FFAE00" dark x-small >신상품</v-chip></v-flex>
                                        <v-flex v-if="product.isPopular" shrink class="pr-1"><v-chip color="#32C081" dark x-small >인기</v-chip></v-flex>
                                        <v-flex v-if="product.isBest" shrink class="pr-1"><v-chip color="#1AB5BB" dark x-small >베스트</v-chip></v-flex>
                                    </v-layout>
                                </div>
                            </router-link>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="border-2 grey lighten-1"/>

                <div class="mt-30px mt-md-40px">
                    <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" color="primary"/>
                </div>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import ShopBanner from "@/components/client/shop/shop-banner.vue";

export default {
    components: {
        ShopBanner
    },
    data(){
        return {
            filter: {
                type: "main",
                _category: null
            },

            category: null,

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,
            sort: null,
            sortItems: [
                { text: ":: 순서선택 ::", value: null },
                { text: "최근등록순", value: "byLatest" },
                { text: "인기순", value: "byPopular" },
                { text: "낮은가격순", value: "byLowPrice" },
                { text: "높은가격순", value: "byHighPrice" },
            ],

            summary: { totalCount: 0 },
            products: [],
            
            banners: [
                // {
                //     image: "/images/shop/children/children-banner.jpg",
                //     link: "https://front.wemakeprice.com/product/716425438",
                // },
                
                // {
                //     image: "/images/shop/children/children-banner2.jpg",
                //     link: "https://www.tmon.co.kr/deal/25154901858",
                // },
                {
                    image: "/images/shop/children/children-banner3.jpg",
                    link: "https://www.daehanbooks.co.kr/shop/products/655d6ea5538ec582ae0e3253",
                },
            ],
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { categories } = await api.v1.shop.categories.gets({ params: { depth: 1 } });
            this.category = categories.find(category => category.code == "book")?.children?.find?.(category => category.code == "children");
            console.log(this.$route.query._category)
            this.filter._category = this.$route.query._category ? this.$route.query._category : this.category?._id;
            // this.filter._category = this.$route.query._category || this.category?._id;

            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({ query: { ...this.filter, page: this.page } });
            }
            let { summary, products } = await api.v1.shop.products.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                    sort: this.sort
                },
                params: this.filter
            });

            this.products = products;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.shop}`); },
        less(){ return this.category?.children?.length ? 12 / (this.category.children.length + 1) : 1 }
    },
    watch: {
        "filter._category"(){
            this.page = 1;
            this.search(true);
        },
        // "$route.query.category"(){
        //     this.filter._category = this.$route.query.category
        // },
        "$route.query": {
            deep: true,
            handler(){
                this.page = +this.$route.query.page || 1;
                this.filter._category = this.$route.query._category
                this.search(false);
                window.scrollTo({ top: 0 });
            }
        }
    }
}
</script>
<style scoped>
.v-btn-toggle>>>.v-btn {
    opacity: 1 !important;
}
</style>